import React from 'react';
import { useTranslate } from '../../contexts/languageContext';

const TablaTerritorios_Cabecera = () => {
    const t = useTranslate();
    return(
        <thead>
        <tr>
            <th>{t('territoriosMayuscula')}</th>
            <th>{t('partidoMasVotado')}</th>
            <th colSpan="2">{t('mesasInf')}</th>
            <th colSpan="2">{t('votantes')}</th>
        </tr>
    </thead>
    );
};

export default TablaTerritorios_Cabecera;